import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { actor: String }

  connect() {
    this.applyActor(this.actorValue)
  }

  actorChanged(event) {
    this.applyActor(event.target.value)
  }

  applyActor(actor) {
    const modalBox = this.element.closest(".modal-box")
    if (!modalBox) return
    const select = modalBox.querySelector("select[name='lesson[cancellation_reason_code]']")
    if (!select) return

    select.querySelectorAll("optgroup").forEach((group) => {
      group.disabled = group.dataset.actor !== actor
    })
    select.value = ""
  }
}
